// This file is auto-generated during build
export const version: string = "19.0_2633";
